import React from 'react';
import TextSize from '../components/text-size/TextSize'
const Text = () => {
  return(
    <TextSize />
  )
};

export default Text;